import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-114f291a")

_pushScopeId("data-v-114f291a")
const _hoisted_1 = { class: "mb-3 p-3 wf-promo -mx-3" }
const _hoisted_2 = { class: "m-0 mb-1 wf-color-pink-500" }
const _hoisted_3 = { class: "m-0 mb-2 wf-color-pink-600" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Вступите в сеть и получите ")
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "my-0" }, "рекламный тур бесплатно", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("! ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Chip = _resolveComponent("Chip")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.season) + " акция!", 1),
    _createVNode("h3", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Chip, { class: "wf-bg-orange-100 wf-color-pink-500" }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ]))
})